import React, { Component } from "react";
import LabelInput from "./label/LabelInput";
import ValidateMessageError from "./validate-message-error/ValidateMessageError";
import "../css/main.css";
import { Select } from 'antd';

const { Option } = Select;

interface Props {
  options: any;
  label: string;
  name: string;
  wrappedClass: string;
  firstOptionLabel: string;
  onChange?: any;
  value: any;
  error?: any;
  isRequired?:boolean;
  isDisabled?:boolean;
  isAllowClear?:boolean;
  checkUpdate? : boolean
  onBlur? : any;
}
interface State {}

export default class SelectBoxAgency extends Component<Props, State> {
  state = {};
  onChange = () => {};
  onBlur = () => {};
  onFocus = () => {};
  onSearch = () => {};

  render() {
    const { options } = this.props;
    const isUpdate = !!this.props.checkUpdate
    return (
      <div className={this.props.wrappedClass}>
        <LabelInput
          nameFor={this.props.name}
          label={this.props.label}
          isRequired={this.props.isRequired}
        />

        <Select
            optionFilterProp="children"
            showSearch
            style={{ width: '100%' }}
            placeholder={this.props.firstOptionLabel}
            onChange={this.props.onChange}
            onFocus={this.onFocus}
            onBlur={this.props.onBlur}
            onSearch={this.onSearch}
            allowClear={this.props.isAllowClear ? this.props.isAllowClear : true}
            disabled={this.props.isDisabled}
            value={isUpdate ? (this.props.value ? String(this.props.value) : '') : (this.props.value ? String(this.props.value) : this.props.firstOptionLabel)}
        >
            {Object.keys(options).map((key, index) => (
                <Option  key={key} value={key} title={options[key]}>
                    {options[key]}
                </Option>
            ))}
        </Select>

       <ValidateMessageError error={this.props.error}/>
      </div>
    );
  }
}
